import script from "./ExternalLinkButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalLinkButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"ExternalLinkButton.vue"]])

export default __exports__